module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-700.e2164d75fecd0d0e5ca2.ttf";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-700.ttf
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-700.ttf
// module chunks = styles